import { validate } from "uuid";

export const isUUIDValid = (data: unknown): boolean => validate(data);
